// Quiz "Che stile di arredamento sei?" — 5 stili: C/B/I/S/M
// Le immagini sono facilmente sostituibili con foto proprietarie qui sotto.

export const BOOKING_LINK = "https://francescaspinazzola.it/#contatti";

export const STYLE_IMAGES = {
  C: "https://images.unsplash.com/photo-1455593984172-9f753a2e1ebd?auto=format&fit=crop&w=1400&q=70",
  B: "https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&w=1400&q=70",
  I: "https://images.unsplash.com/photo-1505873242700-f289a29e1e0f?auto=format&fit=crop&w=1400&q=70",
  S: "https://images.unsplash.com/photo-1528908929486-dfaa209c6986?auto=format&fit=crop&w=1400&q=70",
  M: "https://images.pexels.com/photos/269218/pexels-photo-269218.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const ARR_QUESTIONS = [
  {
    id: 1,
    question:
      "Entri in una casa e ti senti subito a tuo agio. Cosa vedi?",
    options: [
      { style: "C", text: "Legno scuro, tappeti importanti e quadri alle pareti" },
      { style: "B", text: "Piante ovunque, cesti intrecciati e tessuti dal mondo" },
      { style: "I", text: "Mattoni a vista, metallo nero e soffitti alti" },
      { style: "S", text: "Toni pastello, legno decapato e fiori freschi" },
      { style: "M", text: "Spazi liberi, pochi oggetti, tanta luce" },
    ],
  },
  {
    id: 2,
    question: "Il tuo divano ideale è...",
    options: [
      { style: "C", text: "In pelle capitonné o velluto, con braccioli importanti" },
      { style: "B", text: "Coperto di cuscini colorati, uno diverso dall'altro" },
      { style: "I", text: "In cuoio vissuto, magari con la struttura in metallo a vista" },
      { style: "S", text: "Bianco o cipria, in lino, morbido e avvolgente" },
      { style: "M", text: "Lineare, grigio o beige, senza fronzoli" },
    ],
  },
  {
    id: 3,
    question: "Che luce preferisci in soggiorno?",
    options: [
      { style: "C", text: "Un lampadario elegante al centro della stanza" },
      { style: "B", text: "Lucine, lanterne e luce calda diffusa" },
      { style: "I", text: "Lampade a sospensione in stile fabbrica, con lampadine a vista" },
      { style: "S", text: "Abat jour romantiche e candele accese" },
      { style: "M", text: "Faretti nascosti e luce indiretta, che non si vede da dove arriva" },
    ],
  },
  {
    id: 4,
    question: "Il materiale che ti fa innamorare:",
    options: [
      { style: "C", text: "Il marmo" },
      { style: "B", text: "Il rattan e il vimini" },
      { style: "I", text: "Il ferro battuto e il cemento" },
      { style: "S", text: "Il legno sbiancato dal tempo" },
      { style: "M", text: "Il vetro e le superfici opache" },
    ],
  },
  {
    id: 5,
    question: "La tua palette di colori ideale:",
    options: [
      { style: "C", text: "Bordeaux, blu notte, oro e toni caldi profondi" },
      { style: "B", text: "Terracotta, senape, verde salvia e tinte speziate" },
      { style: "I", text: "Grigio, nero, ruggine e tonalità metalliche" },
      { style: "S", text: "Bianco, rosa antico, lavanda e celeste polvere" },
      { style: "M", text: "Bianco, sabbia, grigio chiaro, massimo tre tinte neutre" },
    ],
  },
  {
    id: 6,
    question: "Sul comodino tieni:",
    options: [
      { style: "C", text: "Una lampada classica e un libro rilegato" },
      { style: "B", text: "Un incenso, una pianta piccola e i tuoi gioielli in una ciotolina" },
      { style: "I", text: "Solo la sveglia, appoggiata su una cassettiera di recupero" },
      { style: "S", text: "Una cornice con una foto e un vasetto di fiori" },
      { style: "M", text: "Niente, o quasi niente" },
    ],
  },
  {
    id: 7,
    question: "Il tuo mercato ideale del sabato mattina:",
    options: [
      { style: "C", text: "Un antiquario con mobili d'epoca" },
      { style: "B", text: "Un mercatino etnico con tessuti, ceramiche e oggetti fatti a mano" },
      { style: "I", text: "Un deposito di modernariato e pezzi di recupero industriale" },
      { style: "S", text: "Una brocante francese piena di pizzi e porcellane" },
      { style: "M", text: "Nessun mercato, compro solo quello che mi serve, quando mi serve" },
    ],
  },
  {
    id: 8,
    question: "Le pareti di casa tua:",
    options: [
      { style: "C", text: "Boiserie o carta da parati elegante" },
      { style: "B", text: "Macramè, arazzi e una parete gallery piena di ricordi di viaggio" },
      { style: "I", text: "Mattoni o cemento a vista, al massimo una scritta vintage" },
      { style: "S", text: "Tinte chiare con cornici bianche e specchi decorati" },
      { style: "M", text: "Bianche o quasi, con al massimo un quadro grande" },
    ],
  },
  {
    id: 9,
    question: "Un ospite entra in casa tua, cosa vorresti che pensasse?",
    options: [
      { style: "C", text: '"Che eleganza senza tempo"' },
      { style: "B", text: '"Che energia, qui c\'è il mondo intero"' },
      { style: "I", text: '"Che carattere, sembra un loft di New York"' },
      { style: "S", text: '"Che dolcezza, mi sento in una favola"' },
      { style: "M", text: '"Che pace, qui respiro"' },
    ],
  },
  {
    id: 10,
    question:
      "Se dovessi arredare una casa vacanze domani, da dove partiresti?",
    options: [
      { style: "C", text: "Da un pezzo importante che dia subito prestigio all'ambiente" },
      { style: "B", text: "Dai tessuti e dalle piante, la casa deve raccontare un viaggio" },
      { style: "I", text: "Da un elemento di recupero che diventi il protagonista della stanza" },
      { style: "S", text: 'Dai dettagli romantici che fanno dire "che carino!" alle foto' },
      { style: "M", text: "Dallo spazio: prima tolgo, poi scelgo poche cose giuste" },
    ],
  },
];

export const PROFILES = {
  C: {
    name: "Classico",
    image: STYLE_IMAGES.C,
    description:
      "Eleganza che non passa di moda. Lo stile classico parla di equilibrio, simmetria e materiali nobili: legni scuri, marmi, tessuti pesanti, dettagli dorati. Non rincorre le tendenze perché non ne ha bisogno.",
    caratteristiche:
      "Mobili in legno massello, palette calda e profonda, illuminazione scenografica, quadri e specchi con cornici importanti, simmetria negli accostamenti.",
    perChi:
      "A chi ama la sensazione di solidità e accoglienza formale. Negli affitti brevi funziona benissimo per appartamenti in palazzi d'epoca e centri storici, dove l'ospite cerca l'esperienza \"da palazzo italiano\".",
    consiglio:
      "Il classico rischia il pesante: alleggeriscilo con tende chiare e luce calda ben distribuita, e lascia respiro tra i mobili. L'eleganza ha bisogno di spazio.",
  },
  B: {
    name: "Boho",
    image: STYLE_IMAGES.B,
    description:
      "La casa come diario di viaggio. Il boho mescola epoche, culture e materiali naturali con una libertà studiata: niente è in coordinato, tutto è in armonia.",
    caratteristiche:
      "Fibre naturali (rattan, juta, vimini), tessuti sovrapposti, piante in abbondanza, artigianato etnico, palette terrosa e speziata.",
    perChi:
      "A spiriti creativi e viaggiatori. Negli affitti brevi è lo stile che fotografa meglio per un pubblico giovane e internazionale, perfetto per case al mare, borghi e contesti bohémien.",
    consiglio:
      "Il confine tra boho e caos è sottile: scegli una palette di 3-4 tinte terrose e falle tornare in ogni stanza, così la varietà diventa stile e non disordine.",
  },
  I: {
    name: "Industrial",
    image: STYLE_IMAGES.I,
    description:
      "La bellezza delle cose vere. Nato nei loft ricavati dalle fabbriche, celebra i materiali nudi: mattone, cemento, metallo, legno vissuto. Imperfetto per scelta, mai per trascuratezza.",
    caratteristiche:
      "Strutture a vista, metallo nero, pezzi di recupero, cuoio, grandi volumi, illuminazione in stile officina.",
    perChi:
      "A chi ha un'anima urbana e ama gli spazi con carattere. Negli affitti brevi conquista il pubblico dei city break, ideale per loft, ex spazi commerciali e città d'arte con un'anima contemporanea.",
    consiglio:
      "L'industrial puro può risultare freddo in foto: scalda sempre con legno, tessili e luce calda. Il contrasto morbido/ruvido è quello che fa scattare la prenotazione.",
  },
  S: {
    name: "Shabby / Romantico",
    image: STYLE_IMAGES.S,
    description:
      "La poesia delle cose vissute. Legni decapati, bianchi sporchi, rose e porcellane: lo shabby racconta una dolcezza d'altri tempi, dove ogni segno del tempo è un pregio.",
    caratteristiche:
      "Mobili patinati o decapati, palette pastello, pizzi e lini, fiori freschi o secchi, specchi e cornici decorate.",
    perChi:
      "A chi cerca atmosfera e tenerezza. Negli affitti brevi è imbattibile per casali, B&B di campagna e case romantiche pensate per coppie, dove le foto devono trasmettere calore prima ancora che design.",
    consiglio:
      'Per non scivolare nel "casa della nonna", tieni le superfici libere e i decori in numero dispari: tre oggetti ben scelti valgono più di dieci.',
  },
  M: {
    name: "Minimal",
    image: STYLE_IMAGES.M,
    description:
      "Il lusso dello spazio vuoto. Il minimal non è assenza, è selezione: pochi elementi, tutti giusti, e la luce come vero protagonista dell'ambiente.",
    caratteristiche:
      "Palette neutra, linee pulite, contenimento a scomparsa, materiali opachi, assenza di decoro superfluo.",
    perChi:
      "A chi cerca ordine mentale prima ancora che estetico. Negli affitti brevi è lo stile più facile da mantenere e pulire tra un ospite e l'altro, perfetto per business travel e soggiorni urbani.",
    consiglio:
      "Minimal non significa spoglio: in foto rischia di sembrare vuoto, aggiungi sempre 2-3 punti di calore (una pianta, un plaid, legno naturale) che diano vita all'inquadratura.",
  },
};

// Winner: most chosen; tie-break by most recent question (10 -> 1)
export function computeStyle(answers) {
  const counts = { C: 0, B: 0, I: 0, S: 0, M: 0 };
  ARR_QUESTIONS.forEach((q) => {
    const s = answers[q.id];
    if (s && counts[s] !== undefined) counts[s] += 1;
  });
  const values = Object.values(counts);
  if (!values.some((v) => v > 0)) return { style: null, counts };
  const top = Math.max(...values);
  const tied = Object.keys(counts).filter((s) => counts[s] === top);
  if (tied.length === 1) return { style: tied[0], counts };
  for (let qid = 10; qid >= 1; qid--) {
    const s = answers[qid];
    if (tied.includes(s)) return { style: s, counts };
  }
  return { style: tied[0], counts };
}

// Shuffle helper (Fisher-Yates)
export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
